import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=2d2291b9&scoped=true&"
import script from "./NotificationPopup.vue?vue&type=script&lang=js&"
export * from "./NotificationPopup.vue?vue&type=script&lang=js&"
import style0 from "./NotificationPopup.vue?vue&type=style&index=0&id=2d2291b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2291b9",
  null
  
)

export default component.exports